'use es6';

import { CODEMIRROR_OPTIONS_FETCH, CODEMIRROR_OPTIONS_UPDATE } from 'DesignData/actions/ActionTypes';
import { getUserId } from 'DesignData/selectors/auth';
import { fetchSettings, updateSettings } from 'react-codemirror/util/UserSettings';
/**
 * Useful with `react-codemirror/decorator/userSettings` prop callbacks
 *  - onUserSettingsFetchSuccess
 *  - onUserSettingsChange
 * @param {Object} settings
 */

export function hydrate(settings) {
  return {
    type: CODEMIRROR_OPTIONS_FETCH,
    options: settings
  };
}
/**
 * Fetch options data for all CodeMirror instances.
 */

export function fetch() {
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    fetchSettings({
      userId,

      onSuccess({
        settings
      }) {
        dispatch(hydrate(settings));
      }

    });
  };
}
/**
 * Changes options data for an individual CodeMirror editor.
 *
 * @param  {Object} settings   Options data specific for all CodeMirror instances.
 */

export function update(settings) {
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    updateSettings({
      userId,
      settings,

      onSuccess({
        settings: options
      }) {
        dispatch({
          type: CODEMIRROR_OPTIONS_UPDATE,
          options
        });
      }

    });
  };
}